export default "__VITE_ASSET__D1T9_a67__"